import { useState } from "react";

import { searchCustomer } from "src/apis/customerApi";
import { getItemPopupList } from "src/apis/itemApi";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SearchYearSingleForm } from "src/components/common/form/search/SearchYearSingleForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

import {
	defaultSAL2100_R01Filter,
	useSAL2100_R01Store,
} from "./Store_SAL2100_R01";

export const SearchSection_SAL2100_R01 = () => {
	const { SAL2100_R01Filter, setSAL2100_R01Filter } = useSAL2100_R01Store();
	const { compCdList, brandCdList } = useCommonCodeStore();
	const { setCodeSearchModalProps } = useUiuxStore();
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

	const customerFocusId = "SAL2100_R01_customer_search";
	const itemFocusId = "SAL2100_R01_item_search";
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: "customCd",
			category: "거래처",
			focusId: customerFocusId,
			responseMapping: { customCd: "customCd", customNm: "customNm" },
			searchFunction: async (searchText: string) => {
				const response = await searchCustomer(searchText);
				return response.data.data.find((value) => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: SAL2100_R01Filter.customCd,
				customNm: SAL2100_R01Filter.customNm,
			}),
		},
		{
			fieldName: "itemCd",
			category: "품목",
			focusId: itemFocusId,
			responseMapping: { itemCd: "itemCd", itemNm: "itemNm" },
			searchFunction: async (searchText: string) => {
				const response = await getItemPopupList(searchText, "", "", "");
				return response.data.data.find((value) => value.itemCd === searchText);
			},
			extraFilter: () => ({
				itemCd: SAL2100_R01Filter.itemCd,
				itemNm: SAL2100_R01Filter.itemNm,
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: SAL2100_R01Filter,
		setEditData: setSAL2100_R01Filter,
		defaultData: defaultSAL2100_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: "SAL2100_R01_search",
	});

	return (
		<SearchSectionForm>
			<SearchDropDownForm
				label="사업장"
				value={SAL2100_R01Filter.compCd}
				optionList={compCdList}
				onChangeValue={(compCd) => setSAL2100_R01Filter({ compCd })}
			/>
			<SearchYearSingleForm
				label="매출연도"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				value={new Date(SAL2100_R01Filter.year, 0, 1)}
				onChange={(date) => setSAL2100_R01Filter({
					year: (date ?? new Date()).getFullYear(),
				})}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			<SearchCodeModalForm
				label="거래처"
				value={SAL2100_R01Filter.customCd}
				valueLabel={SAL2100_R01Filter.customNm}
				handleFoucsId={customerFocusId}
				onChange={getFieldHandlers("customCd").onChange}
				onDoubleClick={getFieldHandlers("customCd").onDoubleClick}
				onKeyDown={getFieldHandlers("customCd").onEnterKeyDown}
			/>
			<SearchDropDownForm
				label="브랜드"
				value={SAL2100_R01Filter.brandCd}
				optionList={brandCdList}
				onChangeValue={(brandCd) => setSAL2100_R01Filter({ brandCd })}
			/>
			<SearchCodeModalForm
				label="품목코드"
				value={SAL2100_R01Filter.itemCd}
				valueLabel={SAL2100_R01Filter.itemNm}
				handleFoucsId={itemFocusId}
				onChange={getFieldHandlers("itemCd").onChange}
				onDoubleClick={getFieldHandlers("itemCd").onDoubleClick}
				onKeyDown={getFieldHandlers("itemCd").onEnterKeyDown}
			/>
		</SearchSectionForm>
	);
};

export default SearchSection_SAL2100_R01;
